import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/layout.js");
